export default __webpack_public_path__ + "static/media/joe_rotella.fb31c6b5.jpg";